import React, { useEffect } from 'react';
import { Header } from "./Header";
import { Footer } from "./Footer";
import { BecomeOurPartner } from "./BecomeOurPartner";

/*import NavMenu from './NavMenu';*/
import './MyStyles/style.css';
import './MyStyles/mobile-style.css';
import './MyStyles/site.css';
import './MyStyles/site2.css';

function VzyBecomeOurPartnerMain() {
    useEffect(() => {
        document.title = "Become our partner"
    });

    return (
        <div className="app-container">
            
           {/* <NavMenu />*/}
            <Header />
            < BecomeOurPartner />
            <Footer />
        </div>
    );
}

export default VzyBecomeOurPartnerMain;



